<pr-icon-chip
  [icon]="statusIcon()"
  [iconClass]="statusColour()"
  [matTooltip]="errorMessage()"
>
  {{ statusLabel() }}
</pr-icon-chip>
